import axios from 'axios';
import { Formik } from 'formik';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CONTACT } from '../../constants/paths/api';
import { getContactDataModel } from '../../helpers/apiHelpers/contactHelpers';
import { RootState } from '../../store';
import SuccessOrFailure from '../successOrFailure';
import { contactInitialValues, contactSchema } from './contact.schema';
import * as StyledContact from './contact.styles';
import ContactFormFields from './contactFormFields';

interface Props {}

const Contact: FC<Props> = () => {
	const { t } = useTranslation('generalForm');
	const pageReducer = useSelector((store: RootState) => store.pageReducer);
	const { page } = pageReducer;

	const [hasSubmitted, setHasSubmitted] = useState(false);
	const [error, setError] = useState(false);

	const onSubmit = values => {
		const { SendEmailTo } = page.Values;

		const model = getContactDataModel(values, SendEmailTo);
		axios
			.post(CONTACT, model)
			.then(response => {
				setHasSubmitted(true);
				setError(response.data.error);
				window.scrollTo(0, 0);
			})
			.catch(() => {
				setHasSubmitted(true);
				setError(true);
				window.scrollTo(0, 0);
			});
	};

	return (
		<StyledContact.Wrapper>
			{!hasSubmitted && (
				<Formik
					initialValues={contactInitialValues}
					enableReinitialize
					validationSchema={contactSchema}
					onSubmit={onSubmit}>
					{({ handleSubmit, isSubmitting, values, setFieldTouched, setFieldValue, touched, errors }) => (
						<form onSubmit={handleSubmit}>
							<ContactFormFields
								values={values}
								setFieldTouched={setFieldTouched}
								setFieldValue={setFieldValue}
								isSubmitting={isSubmitting}
								touched={touched}
								errors={errors}
							/>
						</form>
					)}
				</Formik>
			)}
			<SuccessOrFailure hasSubmitted={hasSubmitted} success={!error} messageArray={[t('successMessage')]} />
		</StyledContact.Wrapper>
	);
};

export default Contact;
